/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class LinkedIn extends React.Component {
  render() {
    return (
			<svg height="30px" width="30px" version="1.1" viewBox="0 0 112.196 112.196" xmlSpace="preserve">
				<circle cx="56.098" cy="56.097" fill=" rgba(var(--ey-spotmentor), 1)" r="56.098"/>
				<path className="active-path" d="m89.616 60.611v23.128h-13.409v-21.578c0-5.418-1.936-9.118-6.791-9.118-3.705 0-5.906 2.491-6.878 4.903-0.353 0.862-0.444 2.059-0.444 3.268v22.524h-13.41s0.18-36.546 0-40.329h13.411v5.715c-0.027 0.045-0.065 0.089-0.089 0.132h0.089v-0.132c1.782-2.742 4.96-6.662 12.085-6.662 8.822 0 15.436 5.764 15.436 18.149zm-54.96-36.642c-4.587 0-7.588 3.011-7.588 6.967 0 3.872 2.914 6.97 7.412 6.97h0.087c4.677 0 7.585-3.098 7.585-6.97-0.089-3.956-2.908-6.967-7.496-6.967zm-6.791 59.77h13.405v-40.33h-13.405v40.33z" fill="#181818"/>
			</svg>
    );
  }
}

export default LinkedIn;



// WEBPACK FOOTER //
// ./src/components/Footer/icons/LinkedIn.js